const CrumbsRightIcon = (props) => {
    return (
        <svg
          width={14}
          height={7}
          viewBox="0 0 14 7"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
        >
          <path
            d="M13.919 2.9L10.808.066a.26.26 0 00-.284-.04.235.235 0 00-.154.235v1.815H.26a.252.252 0 00-.187.072.253.253 0 00-.073.187v1.555c0 .076.024.138.073.187.049.048.11.072.186.072H10.37v1.815c0 .108.052.187.154.235a.253.253 0 00.284-.048l3.111-2.869a.265.265 0 000-.38z"
            fill="#9CB5D8"
          />
        </svg>
      )
}

export default CrumbsRightIcon